import { get, post, put, del } from './api';

// Create a new user
export const createUser = (data) => {
  return post('/users', data);
};


export const getAllUsers = (
  page = 1,
  limit = 10,
  search = '',
  roleId = '',
  branchId = '',
  sortField = '',
  sortOrder = ''
) => {
  const params = new URLSearchParams();

  params.append('page', page);
  params.append('limit', limit);

  if (search) params.append('name', search);
  if (roleId && roleId !== 'All') params.append('role_id', roleId);
  if (branchId && branchId !== 'All') params.append('branch_id', branchId);
  if (sortField) params.append('sort_field', sortField); // ✅ sort field
  if (sortOrder) params.append('sort_order', sortOrder); // ✅ sort order (asc/desc)

  return get(`/users?${params.toString()}`);
};


// Get a user by ID
export const getUserById = (id) => {
  return get(`/users/${id}`);
};

// Update a user
export const updateUser = (id, data) => {
  return put(`/users/${id}`, data);
};

// Delete a user (soft delete if your backend supports it)
export const deleteUser = (id) => {
  return del(`/users/${id}`);
};

// Update user password
export const updateUserPassword = (id, data) => {
  return post(`/users/${id}/update-password`, data);
};
